<div class="legal-disclaimer-container view">
    <div class="title">{{ 'legal-disclaimer.title' | transloco }}</div>
    <div class="legal-disclaimer-container__content">
        <div class="legal-disclaimer-container__content__text left">
            <span>{{ 'legal-disclaimer.paragraph-0' | transloco }}</span>
            <h4>{{ 'legal-disclaimer.paragraph-header-1' | transloco }}</h4>
            <span>{{ 'legal-disclaimer.paragraph-1' | transloco }}</span>
            <h4>{{ 'legal-disclaimer.paragraph-header-2' | transloco }}</h4>
            <span>{{ 'legal-disclaimer.paragraph-2' | transloco }}</span>
        </div>
        <div class="legal-disclaimer-container__content__right">
            <div class="legal-disclaimer-container__content__right__content">
                <div class="legal-disclaimer-container__content__right__img still-life-1"></div>
                <div class="legal-disclaimer-container__content__right__decorator"></div>
            </div>
        </div>
    </div>
    <div class="legal-disclaimer-container__content">
        <div class="legal-disclaimer-container__content__right">
            <div class="legal-disclaimer-container__content__right__content">
                <div class="legal-disclaimer-container__content__right__img still-life-2"></div>
                <div class="legal-disclaimer-container__content__right__decorator"></div>
            </div>
        </div>
        <div class="legal-disclaimer-container__content__text right">
            <h4 class="initial">{{ 'legal-disclaimer.paragraph-header-3' | transloco }}</h4>
            <span>{{ 'legal-disclaimer.paragraph-3' | transloco }}</span>
            <h4 >{{ 'legal-disclaimer.paragraph-header-4' | transloco }}</h4>
            <span>{{ 'legal-disclaimer.paragraph-4' | transloco }}</span>
        </div>
    </div>
    <div class="legal-disclaimer-container__content">
        <div class="legal-disclaimer-container__content__text left">
            <h4>{{ 'legal-disclaimer.paragraph-header-5' | transloco }}</h4>
            <span>{{ 'legal-disclaimer.paragraph-5' | transloco }}</span>
            <h4>{{ 'legal-disclaimer.paragraph-header-6' | transloco }}</h4>
            <span>{{ 'legal-disclaimer.paragraph-6-start' | transloco }}</span>
            <ul style="list-style-type: none;padding: 0;">
                <li style="margin-left: 5px;">{{ 'legal-disclaimer.paragraph-6-ul.1' | transloco }}</li>
                <li style="margin-left: 5px;">{{ 'legal-disclaimer.paragraph-6-ul.2' | transloco }}</li>
                <li style="margin-left: 5px;">{{ 'legal-disclaimer.paragraph-6-ul.3' | transloco }}</li>
                <li style="margin-left: 5px;">{{ 'legal-disclaimer.paragraph-6-ul.4' | transloco }}</li>
            </ul>
            <span>{{ 'legal-disclaimer.paragraph-6-end' | transloco }}</span>            
            <h4>{{ 'legal-disclaimer.paragraph-header-7' | transloco }}</h4>
            <span>{{ 'legal-disclaimer.paragraph-7' | transloco }}</span>
            <h4>{{ 'legal-disclaimer.paragraph-header-8' | transloco }}</h4>
            <span>{{ 'legal-disclaimer.paragraph-8' | transloco }}</span>
        </div>
        <div class="legal-disclaimer-container__content__right">
            <div class="legal-disclaimer-container__content__right__content">
                <div class="legal-disclaimer-container__content__right__img still-life-3"></div>
                <div class="legal-disclaimer-container__content__right__decorator"></div>
            </div>
        </div>
    </div>
</div>
